export default __webpack_public_path__ + "static/media/rewind_color.6bbc64da.png";